import React from "react";

import TourRunner from "../base/TourRunner";

import { proSomnusCreateDealTourConfiguration } from "./configuration";

const ProSomnusCreateDealTour = () => {
  return <TourRunner descriptor={proSomnusCreateDealTourConfiguration} />;
};

export default ProSomnusCreateDealTour;
